import React from 'react';
export function GuaranteeSection() {
  return <section id="guarantee" className="py-12 md:py-16 text-center" style={{
    background: 'var(--lilac)'
  }} data-id="element-123">
      <div className="max-w-[680px] mx-auto px-5" data-id="element-124">
        <div className="fade-in max-w-[580px] mx-auto rounded-[20px] py-10 md:py-12 px-8 md:px-10 relative" style={{
        background: 'var(--white)',
        boxShadow: '0 12px 52px rgba(180,122,138,.15)'
      }} data-id="element-125">
          {/* Badge */}
          <div className="w-[72px] h-[72px] md:w-[80px] md:h-[80px] rounded-full flex flex-col items-center justify-center mx-auto mb-5 font-serif text-[28px] md:text-[30px] font-bold leading-none" style={{
          background: 'linear-gradient(135deg, var(--gold), var(--gold-shine))',
          boxShadow: '0 8px 28px rgba(200,169,110,.4)',
          color: 'var(--ink)'
        }} data-id="element-126">
            7
            <span className="text-[9px] tracking-[1px] font-sans font-normal block" data-id="element-127">
              días
            </span>
          </div>

          <h2 className="font-serif font-normal mb-4" style={{
          fontSize: 'clamp(22px, 4vw, 34px)',
          color: 'var(--ink)'
        }} data-id="element-128">
            Garantía total.
            <br data-id="element-129" />
            <em style={{
            color: 'var(--rose-deep)'
          }} data-id="element-130">
              Sin preguntas, sin burocracia.
            </em>
          </h2>

          <p className="text-[14px] leading-relaxed mb-3" style={{
          color: 'var(--muted)'
        }} data-id="element-131">
            Probá el kit durante 7 días. Hacé al menos un ritual. Si no sentís
            ningún alivio, ningún movimiento emocional, nada —{' '}
            <strong style={{
            color: 'var(--ink)',
            fontWeight: 500
          }} data-id="element-132">
              te devolvemos el 100% de tu dinero
            </strong>
            .
          </p>

          <p className="text-[14px] leading-relaxed mb-3" style={{
          color: 'var(--muted)'
        }} data-id="element-133">
            No queremos tu dinero si esto no funciona para vos. Creemos tanto en
            este proceso que <u data-id="element-134">somos nosotras quienes asumimos el riesgo</u>,
            no vos.
          </p>

          <p className="font-serif text-[17px] italic mt-4" style={{
          color: 'var(--rose-deep)'
        }} data-id="element-135">
            "El único riesgo real es seguir cargando lo que ya podías haber
            soltado."
          </p>
        </div>
      </div>
    </section>;
}